<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>


                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>

                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>

            </div>
            <div v-show="showFV" class="yx-flex-h-end" style="margin-top: 15px;">
                <div>
                    <el-switch v-model="showActiveOnly" @change="changeQueryStatus" active-color="#13ce66" active-text="显示" inactive-text="隐藏" :width="switchLen" :active-value="switchActive" :inactive-value="switchInactive" />
                    <span style="color: rosybrown"> 已关停商户</span>
                </div>
            </div>
            <div class="yx-flex-h-between" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">商户进件</el-button>
            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table :cell-style="columnbackgroundStyle"
                    :data="mchs"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="expand" label="">
                    <template slot-scope="props">
                        <div style="padding: 30px 0 30px 50px; width: 1000px;">
                            <el-descriptions class="margin-top" title="" :column="3" size="mini" border>
                                <template slot="extra">
                                </template>
                                <el-descriptions-item label="商户ID">{{ props.row.id }}</el-descriptions-item>
                                <el-descriptions-item label="服务商ID">{{ props.row.agentId }}</el-descriptions-item>
                                <el-descriptions-item label="业务员ID">{{ props.row.salesmanId }}</el-descriptions-item>
                                <template v-for="(item, index) in props.row.mchExtraChannelInfoWithBLOBsList">
                                    <el-descriptions-item >
                                        <template slot="label">{{item.payChannelCode}}更新时间</template>
                                        {{ item.updateTime }}
                                    </el-descriptions-item>
                                    <el-descriptions-item >
                                        <template slot="label">{{item.payChannelCode}}银联商户号</template>
                                        {{ item.channelCupMchNo }}
                                    </el-descriptions-item>
                                    <el-descriptions-item >
                                        <template slot="label">{{item.payChannelCode}}通道商户号</template>
                                        {{ item.channelMchNo }}
                                    </el-descriptions-item>
                                </template>
                                <el-descriptions-item v-for="(item, index) in props.row.devInfoList">
                                    <template slot="label">终端{{index+1}}SN</template>
                                    {{ item.terSn }}
                                </el-descriptions-item>
                            </el-descriptions>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column prop="mchNo" label="商户号" width="100"></el-table-column>
                <el-table-column prop="mchName" label="商户名称" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shortName" label="简称" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" width="50" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status===1">正常</span>
                        <span v-else style="color: red;">关停</span>
                    </template>
                </el-table-column>

                <el-table-column label="终端数" width="60" align="center">
                    <template slot-scope="scope">
                        {{scope.row.devInfoList?scope.row.devInfoList.length:'-'}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="mchExtraChannelInfoWithBLOBsList"
                        label="进件状态"
                        width="280" >
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-start">
                            <el-tag type="info">
                                {{_enums.ProductChannelConvertEnum.getNameById(item.payChannelCode)}}
                                <i class="header-icon el-icon-loading" v-if="mchChannelWaitingStatusArr.indexOf(item.status)>-1" />
                                <i class="header-icon el-icon-warning-outline" v-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" />
                                {{_enums.ChannelMchStatusEnum.getNameById(item.status)}}
                                <el-tooltip effect="light" v-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" :disabled="item.channelRetMsg===null" placement="top">
                                    <div style="max-width: 200px" slot="content">
                                        <i class="header-icon el-icon-warning"></i>
                                        返回码：{{item.channelRetCode}}
                                        <br>
                                        {{item.channelRetMsg}}
                                    </div>
                                    <i class="header-icon el-icon-error" style="color: red">原因</i>
                                </el-tooltip>
                            </el-tag>
                            <el-tag v-if="_p_env.VUE_APP_MCH_SIGN_MSG_RESEND==='1' && mchChannelWaitingStatusArr.indexOf(item.status)===2" type="success" effect="dark" class="cls-tag2btn" @click="viewSignMsg(scope.row, item)" style="margin-left: 5px; ">
                                <i class="header-icon el-icon-message" /> 重发短信</el-tag>
                            <el-tag v-else-if="mchChannelFailedStatusArr.indexOf(item.status)>-1" type="warning" effect="dark" class="cls-tag2btn" @click="viewEdit(scope.row)" style="margin-left: 5px; ">
                                <i class="header-icon el-icon-edit" />修改</el-tag>
                            <!--
                            <el-tooltip effect="light" v-if="item.status===1 && item.channelRetCode==='3'" :disabled="item.channelRetMsg===null" placement="top">
                                <div style="max-width: 200px" slot="content">
                                    <i class="header-icon el-icon-warning"></i>
                                    返回码：{{item.channelRetCode}}
                                    <br>
                                    {{item.channelRetMsg}}
                                </div>
                                <el-button v-if="item.status===1 && item.channelRetCode==='3'" type="warning" plain size="small" style="padding: 6px" @click="viewEditExt(scope.row)">
                                    <i class="header-icon el-icon-edit" />补充
                                </el-button>
                            </el-tooltip>
                            -->


                        </div>
                    </template>
                </el-table-column>


                <!--
                <el-table-column label="进件状态" prop="mchExtraChannelInfoWithBLOBsList" align="center" width="200">
                    <template slot-scope="scope">
                        <el-table :data="scope.row.mchExtraChannelInfoWithBLOBsList"
                                  :show-header="false"
                                  size="mini"
                                  border="false"
                                  type="expand">
                            <el-table-column label="渠道" prop="payChannelCode" width="50" />
                            <el-table-column label="状态" prop="status">
                                <template slot-scope="scope">
                                    {{_enums.ChannelMchStatusEnum.getNameById(scope.row.status)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                -->


                <!--
                    <el-table-column
                            v-for="(item, index) in _enums.ChannelEnum"
                            :label="item.name"
                            width="100" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.mchExtraChannelInfoWithBLOBsList.length>0">
                                {{_enums.ChannelMchStatusEnum.getNameById(scope.row.mchExtraChannelInfoWithBLOBsList[0].status)}}
                            </span>
                        </template>


                        <template slot="header" slot-scope="scope">
                            {{item.payChannelCode}}
                        </template>
                        <template slot-scope="scope">
                            {{_enums.ChannelMchStatusEnum.getNameById(scope.row.item.status)}}
                        </template>

                </el-table-column>

                <el-table-column prop="salesmanName" label="实名认证" width="100"></el-table-column>
                                <el-table-column prop="mchExtraInfo.adsAddress" label="详细地址" width="250" show-overflow-tooltip></el-table-column>

 -->
                <!--
                <el-table-column prop="mchExtraChannelInfoWithBLOBsList" label="通道商户号" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-between">
                            <el-tag class="txt-tag">{{item.payChannelCode}}</el-tag>{{item.channelMchNo}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="mchExtraChannelInfoWithBLOBsList" label="银联商户号" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.mchExtraChannelInfoWithBLOBsList" class="yx-flex-h-between">
                            {{item.payChannelCode}}: {{item.channelCupMchNo}}
                        </div>
                    </template>
                </el-table-column>
                -->
                <!--
                <el-table-column prop="id" label="商户ID" width="180"></el-table-column>
                -->

                <el-table-column prop="salesmanName" label="客户经理" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="agentName" label="服务商" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createWay" label="创建方式" width="80">
                    <template slot-scope="scope">{{_enums.MchCreateWayEnum.getNameById(scope.row.createWay)}}</template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="140"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center">
                            <!--
                                <div class="yx-flex-h-center" >
                                    <el-button type="text"  size="mini" @click="viewDetail(scope.row)">详情</el-button>
                                    <el-button type="text"  size="mini" @click="viewEditExt(scope.row)">操作</el-button>
                                </div>
                            -->
                            <el-dropdown trigger="click" @command="onOpt">
                              <span class="el-dropdown-link">操作<i class="el-icon-arrow-down el-icon--right"/></span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item icon="el-icon-document" :command="{opt: 'VIEW', data: scope.row}">查看详情</el-dropdown-item>
                                    <!--
                                    <el-dropdown-item icon="el-icon-edit-outline" :command="{opt: 'CHANGE', data: scope.row}">变更信息</el-dropdown-item>
                                    -->
                                    <el-dropdown-item icon="el-icon-document-add" :command="{opt: 'ADD_PRD', data: scope.row}">添加产品</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>

                        <!--
                        <el-button type="primary" plain size="mini" style="padding: 5px" @click="viewDetail(scope.row)">查看</el-button>
                        <el-button v-if="scope.row.status===1" type="warning" plain size="mini" style="padding: 5px" @click="viewChange(scope.row)">变更</el-button>
                        <el-button
                                type="success" plain size="mini" style="padding: 5px" @click="viewAddPrd(scope.row)"
                                v-if="scope.row.status===1 && scope.row.mchExtraChannelInfoWithBLOBsList!==null && scope.row.mchExtraChannelInfoWithBLOBsList.length<2"
                        >增产品</el-button>
                        -->
                        <!-- 变更，当所有进件全部成功后，才允许变更
                        <el-button
                                type="warning" plain size="mini" style="padding: 5px" @click="viewChange(scope.row)"
                                v-if="scope.row.mchExtraChannelInfoWithBLOBsList!==null && scope.row.mchExtraChannelInfoWithBLOBsList.length>0"
                        >变更</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev, pager, next, jumper, ->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

        <el-drawer
                :title=mchInfo.mchName
                :with-header="false"
                :visible.sync="drawer"
                :show-close=false
                size = "65%"
                direction="rtl">
            <div style="padding: 0 10px 30px 10px">
                <el-table :data="[mchInfo]" style="padding-left: 0px">
                    <el-table-column prop="mchNo" label="商户编号" />
                    <el-table-column prop="shortName" label="商户简称" />
                    <el-table-column prop="status" label="状态" >
                        <template slot-scope="scope">
                            {{_enums.MchStatusEnum.getNameById(scope.row.status)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center" />
                </el-table>
            </div>
            <MchDetailDiv :key="mchInfo.id" v-bind:inMchInfo="mchInfo"></MchDetailDiv>
        </el-drawer>

        <MchBaseDlg v-if="$root.g_data_user_product_rate && $root.g_data_business_category" :key="keyCompMchDlg" v-bind:inOptType="dlgModel" v-bind:inMchInfo="mchInfo"  v-bind:outDlgClosed.sync="dlgClosed" />

        <el-dialog
                :title="radio1Text"
                class="dlg-normal"
                style="width: 400px; margin: 200px auto auto;"
                :visible.sync="prdChoseDlgVisible"
                :close-on-click-modal="false">
            <div class="yx-flex-h-center">
                <el-radio-group v-model="radio1" @change="radio1Changed">
                    <el-radio-button
                            :label="_enums.ProductChannelConvertEnum.getNameById(item.payChannelCode)" v-for="(item, index) in radioData"></el-radio-button>
                </el-radio-group>
            </div>
        </el-dialog>


    </div>

</template>

<script>

    import {
    } from "../../utils/cons";
    import {deepClone, findIdxByKeyValue} from '../../utils/datatool'
    import MchDetailDiv from "../../components/mch/MchDetailDiv";
    import MchBaseDlg from "../../components/mch/MchBaseDlg";

    export default {
        name: "MchInfo",
        components: { MchDetailDiv,  MchBaseDlg},
        data() {
            return {
                mchChannelFailedStatusArr: [
                    this._enums.ChannelMchStatusEnum.未知状态.id,
                    this._enums.ChannelMchStatusEnum.进件失败.id,
                    this._enums.ChannelMchStatusEnum.审核驳回.id,
                    this._enums.ChannelMchStatusEnum.变更失败.id,
                    this._enums.ChannelMchStatusEnum.变更审核驳回.id
                ],
                mchChannelWaitingStatusArr: [
                    this._enums.ChannelMchStatusEnum.创建.id,
                    this._enums.ChannelMchStatusEnum.待渠道进件.id,
                    this._enums.ChannelMchStatusEnum.进件成功待审核.id,
                    this._enums.ChannelMchStatusEnum.转人工审核.id,
                    this._enums.ChannelMchStatusEnum.等待预签约.id,
                    this._enums.ChannelMchStatusEnum.待渠道信息变更.id,
                    this._enums.ChannelMchStatusEnum.变更成功待审核.id
                ],
                radio1Text:'选择产品',
                radio1: null,
                radioData: [],
                rowData: null,
                prdChoseDlgVisible: false,
                prdChoseCode: null,
                keyCompMchDlg: null,
                drawer: false,
                disableBtn: true,
                showActiveOnly: 1,
                switchLen: 65,
                switchActive: 0,
                switchInactive: 1,
                mchStatus: "正常商户",
                mchStatuses:[{"id":1,"name":'正常商户'}, {"id":-1,"name":'已注销商户'}],
                dlgModel: '',
                dlgClosed: false,
                showFV: false,
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                mchs: [],

                mchInfo: {
                    id: null,
                    type: null,
                    status: null,
                    mchNo: null,
                    mchName: null,
                    shortName: null,
                    salesmanId: null,
                    salesmanName: null,
                    outMchNo: null,
                    createWay: null,
                    remark: null,
                    mchExtraInfo: {},
                    mchSettleInfo: {},
                    userProductList: [], // 产品信息列表
                    mchExtraChannelInfoWithBLOBsList: [],  // 渠道扩展信息列表
                },
                keywordList: [
                    {id:"agentName",name:"服务商名称"},
                    {id:"agentCode",name:"服务商编号"},
                    {id:"linkPhone",name:"联系电话"}
                ],
                multipleSelection: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    agentStatId: null,
                    agentLevelId: null,
                    agentPid: null
                }
            }
        },
        mounted() {
            this.initMchs();
        },
        watch: {
            dlgClosed: {
                handler: function (val) {
                    if (this.dlgClosed === true) {
                        this.initMchs();
                    }
                }
            },
        },
        methods: {
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            radio1Changed() {
                let index = -1;
                this.rowData.mchExtraChannelInfoWithBLOBsList.forEach((item,idx) => {
                    if(this._enums.ProductChannelConvertEnum[this.radio1].id===item.payChannelCode) {
                        index = idx;
                    }
                });

                this.mchInfo = deepClone(this.rowData);

                this.mchInfo.mchExtraInfo = deepClone(this.rowData.mchExtraChannelInfoWithBLOBsList[index].objMchExtraInfo);
                this.mchInfo.mchSettleInfo = deepClone(this.rowData.mchExtraChannelInfoWithBLOBsList[index].objMchSettleInfo);

                this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                this.mchInfo.mchExtraChannelInfoWithBLOBsList.push(this.rowData.mchExtraChannelInfoWithBLOBsList[index]);

                this.mchInfo.userProductList = [];
                this.rowData.userProductList.forEach(item => {
                    if(this._enums.ProductChannelCodeConvertEnum.getNameById(item.productCode)===this.rowData.mchExtraChannelInfoWithBLOBsList[index].payChannelCode)
                        this.mchInfo.userProductList.push(item);
                });

                this.prdChoseDlgVisible = false;

//                console.log("mchExtraChannelInfoWithBLOBsList",JSON.stringify(this.mchInfo.mchExtraChannelInfoWithBLOBsList));
//                console.log("userProductList",JSON.stringify(this.mchInfo.userProductList));

                /**
                if(this.dlgModel==='UPD_EXT') {
                    this.keyCompMchDlg = Date.now();
                    this.dlgClosed = false;
                }
                else */
                if(this.dlgModel==='UPD') {
                    this.keyCompMchDlg = Date.now();
                    this.dlgClosed = false;
                }
                else if(this.dlgModel==='VIEW') {
                    this.drawer = true;
                }

            },
            initChoseChannel(data) {
                this.rowData = data;
                this.radio1 = null;
                this.radioData = [];

                if(this.dlgModel==='UPD') {
                    this.radio1Text = '修改产品';
                    data.mchExtraChannelInfoWithBLOBsList.forEach(item => {
                        if(this.mchChannelFailedStatusArr.indexOf(item.status)>-1) {
                            this.radioData.push(item);
                        }
                    });
                }
                /**
                else if(this.dlgModel==='UPD_EXT') {
                    this.radio1Text = '补充产品';
                    data.mchExtraChannelInfoWithBLOBsList.forEach(item => {
                        if(item.status===1 || item.channelRetCode==='3') {
                            this.radioData.push(item);
                        }
                    });
                }*/
                else if(this.dlgModel==='VIEW') {
                    this.radio1Text = '查看产品';
                    data.mchExtraChannelInfoWithBLOBsList.forEach(item => {
                        this.radioData.push(item);
                    });
                }

            },
            viewAdd() {
                this.dlgModel = 'INS';
                this.keyCompMchDlg = Date.now();
                this.dlgClosed = false;

            },
            viewEdit(data) {
                this.dlgModel = 'UPD';
                this.initChoseChannel(data);
                if(this.radioData.length>0)
                    this.prdChoseDlgVisible = true;
                else
                    this.$message.warning("没有需要修改的产品!");
            },
            /***/
            viewEditExt(data) {
                this.dlgModel = 'UPD_EXT';
                this.initChoseChannel(data);
                if(this.radioData.length>0)
                    this.prdChoseDlgVisible = true;
                else
                    this.$message.warning("没有需要补充的产品!");
            },
            viewAddPrd(data) {
                this.dlgModel = 'ADD_PRD';
                this.mchInfo = deepClone(data);
                this.mchInfo.mchExtraInfo = deepClone(data.mchExtraChannelInfoWithBLOBsList[0].objMchExtraInfo);
                this.mchInfo.mchSettleInfo = deepClone(data.mchExtraChannelInfoWithBLOBsList[0].objMchSettleInfo);

                this.mchInfo.mchExtraChannelInfoWithBLOBsList = [];
                this.mchInfo.mchExtraChannelInfoWithBLOBsList.push(data.mchExtraChannelInfoWithBLOBsList[0]);


                this.keyCompMchDlg = Date.now();
                this.dlgClosed = false;
            },
            viewChange(data) {
                this.$message.error("暂未上线!");

            },
            viewSignMsg(mch, channelExtra) {
                this.$confirm('向商户【' + mch.mchName + '】,手机号【' + mch.mchExtraInfo.legalPhone + '】重发签约短信？',
                    '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                    this.postRequest("/mch/signMsgSend", {
                        id: channelExtra.mchId,
                        payChannelCode: channelExtra.payChannelCode
                    }).then(resp => {
                        if (resp) {
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            onOpt(command) {
                if (command.opt === 'VIEW') {
                    this.viewDetail(command.data)
                } else if (command.opt === 'ADD_PRD') {
                    this.viewAddPrd(command.data)
                } else if (command.opt === 'CHANGE') {
                    this.viewChange(command.data)
                }
            },
            viewDetail(data) {
                this.dlgModel = 'VIEW';
                this.initChoseChannel(data);
                this.prdChoseDlgVisible = true;
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initMchs();
            },
            changeQueryStatus() {
                this.searchDo()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            initMchs() {
                this.loading = true;
                let url = '/mch/mchInfo?page=' + this.page + '&size=' + this.size;
                if (this.showActiveOnly===1)
                    url = url + '&status=1';
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.mchs = resp.data;
                        //this.total = Number(resp.total);
                        this.total = resp.total;

                    }
                })
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initMchs();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initMchs();
            },
            exportData() {
            },
        }

    }
</script>

<style scoped>
    .el-dropdown-link {
        font-size: 12px;
        cursor: pointer;
        color: #409EFF;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }
    .demonstration {
        display: block;
        color: #8492a6;
        font-size: 14px;
        margin-bottom: 20px;
    }
</style>
